import { RouterLink } from '@angular/router';
import { Component, ChangeDetectionStrategy, signal } from '@angular/core';

import { Magazine } from '@models/magazine';
import { FormComponent } from '@classes/form';
import { AssetFormatterPipe } from '@pipes/asset-formatter-pipe';

@Component({
  selector: 'app-magazine-list',
  imports: [RouterLink, AssetFormatterPipe],
  templateUrl: './magazine-list.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './magazine-list.scss',
})
export class MagazineList extends FormComponent {
  override data = signal<Magazine[]>([]);
  ngOnInit(): void {
    this.loadEndpoint = 'api/archive';

    this.load();
  }

  override onLoadSuccess(response: any): void {
    this.data.set(response.data);

    super.onLoadSuccess(response);
  }
}
